<div>
  <div [ngClass]="setClasses()">
    <input (change)="onToggle(topping)" type="checkbox" />
    {{ topping.name }}
  </div>
</div>
